import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SelectBox } from 'cbc-shared-lib';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { CodeConversionMstDto, ExtractionconditionInfoDto, LocationgroupsupplypointExtractionconditionInformationDto, Sgkc026aResponse } from 'sg-api';
import { PreSelectBox } from '../../../../../sg-kc-shared/constants/preSelectBox';
import { EnergyTypeCode } from '../../../../../sg-kc-shared/constants/energyTypeCode ';

/**
 * 早見表出力画面(検索条件)
 * @exports
 * @class Sgkc041dReferenceTableSearchConditionComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc041d-reference-table-search-condition',
    templateUrl: './sgkc041d-reference-table-search-condition.component.html',
    styleUrl: './sgkc041d-reference-table-search-condition.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc041dReferenceTableSearchConditionComponent implements OnInit, OnDestroy {

    /** 各必須項目の初期値 */
    readonly DEFAULT_SELECT_VALUE = " ";
    readonly DEFAULT_DATE_VALUE = "-------";

    /** 検索ボタン押下イベント */
    @Output() onClickSearchEvent = new EventEmitter<void>();
    /** クリアボタン押下イベント */
    @Output() onClickClearEvent = new EventEmitter<UntypedFormGroup>();
    /** 単価表承認権限取得APIレスポンス */
    @Input() sgkc026aResponse: Sgkc026aResponse;
    /** コード変換マスタレスポンス */
    @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;;
    /** 検索情報格納FormGroup */
    tankatableConditionInfo: UntypedFormGroup;
    /** 会社 */
    companycode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** エネルギー種別 */
    energyClscode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** LP販売形態 */
    lpSalesformcode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 地点群供給地点区分番号 */
    locationgroupSuppntDivisionnumber: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 対象年月 */
    searchTargetYm: UntypedFormControl = new UntypedFormControl({ value: '', disabled: false }, Validators.required);
    /** コード変換マスタから受け取る会社名のセレクトボックスデータ */
    preCompanyTypeList: PreSelectBox[] = [];
    /** コード変換マスタから受け取るエネルギー種別のセレクトボックスデータ */
    preEnergyTypeList: PreSelectBox[] = [];
    /** コード変換マスタから受け取るLP販売形態のセレクトボックスデータ */
    preLpSalesFormTypeList: PreSelectBox[] = [];
    /** 単価表承認権限取得APIから受け取る地点群/供給地点区分名称のセレクトボックスデータ(地点群供給地点区分抽出条件情報リスト) */
    preChitenTypeList: LocationgroupsupplypointExtractionconditionInformationDto[] = [];

    /** 会社名のセレクトボックスデータ */
    companyTypeList: SelectBox[] = [];
    /** エネルギー種別のセレクトボックスデータ */
    energyTypeList: SelectBox[] = [];
    /** LP販売形態のセレクトボックスデータ */
    lpSalesFormTypeList: SelectBox[] = [];
    /** 地点群/供給地点区分名称のセレクトボックスデータ */
    chitenTypeList: SelectBox[] = [];
    /** 抽出条件情報リスト */
    extractionConditionInformationList: ExtractionconditionInfoDto[] = [];

    /** コンストラクタ 
     * @param {UntypedFormBuilder} fb - フォームビルダー
     * @param {FormGroupDirective} parent - 親フォームグループディレクティブ
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
    */
    constructor(
        private fb: UntypedFormBuilder,
        private parent: FormGroupDirective
    ) { }

    /** 
     * 初期処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    ngOnInit(): void {
        this.tankatableConditionInfo = this.fb.group({
            companycode: this.companycode,
            energyClscode: this.energyClscode,
            lpSalesformcode: this.lpSalesformcode,
            locationgroupSuppntDivisionnumber: this.locationgroupSuppntDivisionnumber,
            searchTargetYm: this.searchTargetYm,
        });
        this.parentForm = this.parent.form;
        this.parentForm.addControl('tankatableConditionInfo', this.tankatableConditionInfo);
    }
    /** 
     * コンポーネント破棄処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    ngOnDestroy(): void {
        if (this.parentForm) {
            this.parentForm.clearValidators();
            this.parentForm.updateValueAndValidity();
            this.parentForm.removeControl('tankatableConditionInfo');
        }
    }

    /**
    * プロパティが変更されたときに、その変更に関する情報を提供する。
    * @param {SimpleChanges} changes
    */
    ngOnChanges(changes: SimpleChanges) {
        // 対象プロパティが変更された場合のみ処理する
        if (changes.codeConversionMstMap && this.codeConversionMstMap) {
            this.preCompanyTypeList.push(...this.getSelectBoxFromCodeConversionMst("S900020"));
            this.preEnergyTypeList.push(...this.getSelectBoxFromCodeConversionMst("S100020"));
            this.preLpSalesFormTypeList.push(...this.getSelectBoxFromCodeConversionMst("S100110"));
        }
        if (changes.sgkc026aResponse && this.sgkc026aResponse) {
            // 抽出条件情報リスト
            this.extractionConditionInformationList = this.sgkc026aResponse.extractionconditionInformationlist;
            // 地点群供給地点区分抽出条件情報リスト
            this.preChitenTypeList = this.sgkc026aResponse.locationgroupsupplypointExtractionconditionInformationlist;
        }
        if (this.codeConversionMstMap && this.sgkc026aResponse) {
            this.setSelectBox();
        }
    }

    /** 
    * 会社選択後の処理
    * @memberof Sgkc021dTankaTableSearchConditionComponent
    */
    onChangeCompany(): void {
        // 会社コードの以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['energyClscode'].disable();
        this.tankatableConditionInfo.controls['energyClscode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['lpSalesformcode'].disable();
        this.tankatableConditionInfo.controls['lpSalesformcode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        // エネルギー種別のセレクトボックスデータを設定する
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value

        // 単価表承認権限取得APIで取得したデータを選択した会社名に一致するデータだけ残す。
        const companyfilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType; // companycodeが一致するかチェック
        });

        // companyfilteredListをもとに、エネルギー種別のセレクトボックスデータを作成
        const energyTypeArray: string[] = companyfilteredList.map(dto => dto.energyClscode);
        this.energyTypeList = this.makeSelectBoxData(energyTypeArray, this.preEnergyTypeList);
        // リストが複数件存在するときエネルギーのセレクトボックスを活性化
        if (this.energyTypeList.length > 1) {
            this.tankatableConditionInfo.controls['energyClscode'].enable();
        } else if (this.energyTypeList.length === 1) {// リストが1件のときエネルギーのセレクトボックスを活性化、選択を確定
            this.tankatableConditionInfo.controls['energyClscode'].enable();
            this.tankatableConditionInfo.controls['energyClscode'].setValue(this.energyTypeList[0].value);
            this.onChangeEnergy();
        }
    }

    /** 
     * エネルギー種別選択後の処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onChangeEnergy(): void {
        // エネルギー種別以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['lpSalesformcode'].disable();
        this.tankatableConditionInfo.controls['lpSalesformcode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        // 選択したエネルギー種別コードを取得
        const energyType = this.parentForm.get('tankatableConditionInfo.energyClscode')?.value;
        // エネルギー種別がLPガスの場合
        if (energyType === EnergyTypeCode.lpGas) {
            // 選択した会社情報を取得
            const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value
            // 単価表承認権限取得APIで取得したデータを選択した会社名とエネルギー種別コードに一致するデータだけ残す。
            const energyFilteredList = this.extractionConditionInformationList.filter(dto => {
                return dto.companycode === companyType && dto.energyClscode === energyType;
            });
            // LP販売形態のセレクトボックスを設定
            // energyFilteredListをもとに、LP販売形態のセレクトボックスデータを作成
            const lpSalesFormTypeArray: string[] = energyFilteredList.map(dto => dto.lpSalesformcode);
            this.lpSalesFormTypeList = this.makeSelectBoxData(lpSalesFormTypeArray, this.preLpSalesFormTypeList)
            // リストが複数件存在するときLP販売形態のセレクトボックスを活性化
            if (this.lpSalesFormTypeList.length > 1) {
                this.tankatableConditionInfo.controls['lpSalesformcode'].enable();
            } else if (this.lpSalesFormTypeList.length === 1) {// リストが1件のときエネルギーのLP販売形態を活性化、選択を確定
                this.tankatableConditionInfo.controls['lpSalesformcode'].enable();
                this.tankatableConditionInfo.controls['lpSalesformcode'].setValue(this.lpSalesFormTypeList[0].value);
                this.onChangeLpSalesForm();
            }
        }
    }

    /** 
     * LP販売形態選択後の処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onChangeLpSalesForm(): void {
        // LP販売形態以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        // 承認部門を選択
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value
        // 選択したエネルギー種別コードを取得
        const energyType = this.parentForm.get('tankatableConditionInfo.energyClscode')?.value;
        // 選択したLP販売形態を取得
        const lpSalesFormType = this.parentForm.get('tankatableConditionInfo.lpSalesformcode')?.value;
        // 単価表承認権限取得APIで取得したデータを会社コードとLP販売形態に一致するデータだけ残す。
        const chitenTypeFilteredList = this.preChitenTypeList.filter(dto => {
            return dto.lpSalesformcode === lpSalesFormType && dto.companycode === companyType;
        });
        this.chitenTypeList = this.makeChitenSelectBoxData(chitenTypeFilteredList);
        // リストが1件以上存在するとき地点群供給地点区分名称のセレクトボックスを活性化
        if (this.chitenTypeList.length > 1) {
            this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].enable();
        } else if (this.chitenTypeList.length === 1) {
            this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].enable();
            this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.chitenTypeList[0].value);
        }
    }

    /** 
     * 検索ボタン押下処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    onClickSearch(): void {
        this.onClickSearchEvent.emit();
    }

    /** 
     * クリアボタン押下処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    onClickClear(): void {
        this.onClickClearEvent.emit();
        this.setSelectBox();
    }

    /** 
     * 必須項目リスト押下処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    onSelectOpened(controlsName: string, opened: boolean) {
        // 必須項目の値を取得する。
        const targetValue = this.tankatableConditionInfo.controls[controlsName].value;

        // 値が初期値と同じ かつ リストを閉じた場合はnullに更新する（バリデーションの発生）。
        if (targetValue === this.DEFAULT_SELECT_VALUE && !opened) {
            this.tankatableConditionInfo.controls[controlsName].setValue(null);
        }
    }

    /** 
     * 対象年月押下処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    onSearchTargetYmBlur() {
        // 対象年月の値を取得する。
        const searchTargetYm = this.tankatableConditionInfo.controls['searchTargetYm'].value;

        // 対象年月の値が初期値と同じ かつ リストを閉じた場合はnullに更新する（バリデーションの発生）。
        if (searchTargetYm === this.DEFAULT_DATE_VALUE) {
            this.tankatableConditionInfo.controls['searchTargetYm'].setValue(null);
        }
    }

    /** 
     * 検索ボタン表示処理
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    isSearchDisabled(): boolean {
        // 必須項目の値を取得する。
        const companycode = this.tankatableConditionInfo.controls['companycode'].value;
        const energyClscode = this.tankatableConditionInfo.controls['energyClscode'].value;
        const lpSalesformcode = this.tankatableConditionInfo.controls['lpSalesformcode'].value;
        const locationgroupSuppntDivisionnumber = this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].value;
        const searchTargetYm = this.tankatableConditionInfo.controls['searchTargetYm'].value;

        // いずれかの値が初期値だった場合、検索ボタンが非活性となる。        
        // エネルギー種別がLPガスの場合
        if (energyClscode === EnergyTypeCode.lpGas) {
            return companycode === this.DEFAULT_SELECT_VALUE
                || energyClscode === this.DEFAULT_SELECT_VALUE
                || lpSalesformcode === this.DEFAULT_SELECT_VALUE
                || locationgroupSuppntDivisionnumber === this.DEFAULT_SELECT_VALUE
                || searchTargetYm === this.DEFAULT_DATE_VALUE;
        } else {
            return companycode === this.DEFAULT_SELECT_VALUE
                || energyClscode === this.DEFAULT_SELECT_VALUE
                || searchTargetYm === this.DEFAULT_DATE_VALUE;
        }
    }

    /** 
    * 単価表承認権限取得APIで取得したデータをもとに、セレクトボックスデータを作成する
    * @param {string[]} targetList :単価表承認権限取得APIで取得したリスト
    * @param {Array<PreSelectBox>} codeList:コード変換マスタからPreSelectBox
    * @returns {SelectBox[]} - セレクトボックスデータ
    * @memberof Sgkc041dReferenceTableSearchConditionComponent
    */
    makeSelectBoxData(targetList: string[], codeList: Array<PreSelectBox>): SelectBox[] {
        let filteredList: PreSelectBox[];
        let selectBox: SelectBox[]

        // 単価表承認権限取得APIで取得したデータとコード変換マスタから取得したデータを結合
        filteredList = codeList.filter(dto => targetList.includes(dto.value));
        // valueを基準に重複を排除
        filteredList = Array.from(
            new Map(filteredList.map(item => [item.value, item])).values()
        );
        // 項目並び順番で昇順ソート
        filteredList.sort((a, b) => {
            return a.hyojiRowTurn.localeCompare(b.hyojiRowTurn)
        });
        // セレクトボックスに値を格納
        selectBox = filteredList.map(data => ({
            value: data.value,
            viewValue: data.viewValue,
        }))
        return selectBox;
    }

    /** 
     * 地点群供給地点区分抽出条件情報リストをもとに、セレクトボックスデータを作成する
     * @param {Array<LocationgroupsupplypointExtractionconditionInformationDto>} codeList :地点群供給地点区分抽出条件情報リスト
     * @returns {SelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    makeChitenSelectBoxData(codeList: Array<LocationgroupsupplypointExtractionconditionInformationDto>): SelectBox[] {
        let filteredList: LocationgroupsupplypointExtractionconditionInformationDto[];
        let selectBox: SelectBox[]
        // 地点群供給地点区分番号を基準に重複を排除
        filteredList = Array.from(
            new Map(codeList.map(item => [item.locationgroupSuppntDivisionnumber, item])).values()
        );
        // セレクトボックスに値を格納
        selectBox = filteredList.map(data => ({
            value: data.locationgroupSuppntDivisionnumber,
            viewValue: data.locationgroupSuppntDivisionname,
        }))
        return selectBox;
    }

    /** 
     * 会社名のセレクトボックスデータを設定
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    setSelectBox(): void {
        // フォームコントロールに初期値を設定
        this.tankatableConditionInfo.get('searchTargetYm')?.setValue(this.DEFAULT_DATE_VALUE);

        // 会社コードの以降のフォームを非活性かつ値を空白にする。
        this.tankatableConditionInfo.controls['energyClscode'].disable();
        this.tankatableConditionInfo.controls['lpSalesformcode'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        // extractionConditionInformationListよりcompanycodeを取り出しcompanyTypeArrayに格納
        const companyTypeArray: string[] = this.extractionConditionInformationList.map(dto => dto.companycode);
        // 会社名にセレクトボックスデータを設定
        this.companyTypeList = this.makeSelectBoxData(companyTypeArray, this.preCompanyTypeList);
        // 会社名リストが存在するとき、値をセットし会社名のセレクトボックスを活性化
        if (this.companyTypeList.length > 0) {
            this.tankatableConditionInfo.controls['companycode'].enable();
            this.tankatableConditionInfo.controls['companycode'].setValue(this.companyTypeList[0].value);
            this.onChangeCompany();
        }
    }

    /** 
     * コード変換マスタから受け取るセレクトボックスデータを作成
     * @param {string} codeId - コードID
     * @returns {PreSelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc041dReferenceTableSearchConditionComponent
     */
    getSelectBoxFromCodeConversionMst(codeId: string): PreSelectBox[] {
        let preSelectBoxList: PreSelectBox[] = [];
        let codeList: CodeConversionMstDto[] = [];
        if (this.codeConversionMstMap.has(codeId)) {
            codeList = this.codeConversionMstMap.get(codeId);
            if (codeList) {
                codeList.forEach(data => {
                    const select: PreSelectBox = { value: data.userCode, viewValue: data.hyojiCont, hyojiRowTurn: data.hyojiRowTurn };
                    preSelectBoxList.push(select);
                })
            }
        }
        return preSelectBoxList;
    }
}
